import Preloader from '../../../../ui/svg/common/preloader';
import React from 'react';

const PreloaderScreen = () => {
    return (
        <div
            className="flex flex-col items-center justify-center w-full h-full absolute left-0 top-0"
            style={{
                background: 'rgba(255, 255, 255, 0.5)' ,
            }}>
            <Preloader width="25px" height="25px" color="#4f4f4f" />
            Loading...
        </div>
    )
};

export default PreloaderScreen;